interface User {
  last_name: string;
  first_name: string;
  middle_name?: string | null;
}

export const getFullName = (user: User, isInitialsOnly?: boolean) => {
  if (isInitialsOnly) {
    return `${user.last_name} ${user.first_name.charAt(0)}.${user?.middle_name ? ` ${user.middle_name.charAt(0)}.` : ''}`;
  }

  return `${user.last_name} ${user.first_name}${user?.middle_name ? ` ${user.middle_name}` : ''}`;
};

export const getYearsLabel = (years: number | null) => {
  if (!years) return null;

  if (years % 10 === 1 && years % 100 !== 11) {
    return 'год';
  } else if ((years % 10 >= 2 && years % 10 <= 4) && (years % 100 < 12 || years % 100 > 14)) {
    return 'года';
  }

  return 'лет';
};

export const phoneForLink = (phone?: string | null) => {
  if (!phone) return null;
  if (phone.startsWith('+7')) return phone;

  return phone.replace(/^8/, '+7');
};

export const phoneForFrontend = (phone?: string | null, codeIsFourNums?: boolean) => {
  if (!phone) return null;

  if (phone.length === 11 && phone.startsWith('8')) {
    return phone.replace(/^8/, '+7')
      .replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1($2) $3-$4-$5');
  }

  if (phone.length === 12 && phone.startsWith('+7')) {
    if (codeIsFourNums) {
      return phone.replace(/(\d{1})(\d{4})(\d{2})(\d{2})(\d{2})/, '$1($2) $3-$4-$5');
    }

    return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1($2) $3-$4-$5');
  }

  return phone;
};

export const replaceNewLines = (markdown?: string | null) => {
  if (!markdown) return '';

  return markdown.replace(/\n\n/g, '<br/>');
};